import React, { Fragment } from 'react';
import defaultImage from '@/assets/images/no_image_found.png';
import { ListingWithPathImages } from '@/types';

interface ListingInfoWindowProps {
  listings: ListingWithPathImages[];
}

export function ListingInfoWindowListings({ listings }: ListingInfoWindowProps) {
  return (
    <Fragment>
      {listings.map((listingDetails) => {
        return (
          <div key={listingDetails.id} className="card m-2" style={{ maxWidth: '200px' }}>
            {listingDetails.images.length && (
              <a href={listingDetails.listing_path} target="_blank">
                <img
                  src={listingDetails.images[0].url}
                  className="card-img-top"
                  alt={listingDetails.images[0].alt}
                  style={{ width: '100%' }}
                />
              </a>
            )}
            <div className="card-body">
              <div className="card-title fw-bold">{listingDetails.title}</div>
              <div className="card-text">
                ${listingDetails.price} / {listingDetails.beds} beds
              </div>
            </div>
          </div>
        );
      })}
    </Fragment>
  );
}
